/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ChartBoxIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M5 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3zm14.584 7.812a1 1 0 1 0-1.168-1.624l-4.42 3.182-3.917-2.785a1 1 0 0 0-1.204.034l-4.5 3.6a1 1 0 0 0 1.25 1.562l3.91-3.129 3.886 2.763a1 1 0 0 0 1.163-.003z" clipRule="evenodd" /></svg>;
};
export default ChartBoxIcon;